import React, {useEffect, useState} from 'react';
import SentenceForm from "../../components/common/SentenceForm";
import Container from "@material-ui/core/Container";
import {makeStyles} from "@material-ui/core";
import ScrollableAnchor from "react-scrollable-anchor";
import Radio from "@material-ui/core/Radio";
import clsx from "clsx";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import RadioGroup from "@material-ui/core/RadioGroup";
import {useRecoilState, useRecoilValue, useSetRecoilState} from "recoil";
import {answerState, menuCheckSelector, selectedMenuItemState, surveyDataState} from "../../state/globalState";

const useStyles = makeStyles(theme => ({
    root: {
        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
    buttons: {
        display: 'flex',
        justifyContent: 'flex-end'
    },
    button: {
        marginTop: theme.spacing(3),
        marginLeft: theme.spacing(1),
    },
    icon: {
        borderRadius: '50%',
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: '#1b6817',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#106ba3',
        },
    },
    textField: {
        width: 300
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
}));

/**
 * 설문 문항 컴포넌트
 */
const Survey8 = (props) => {
    const surveyData = useRecoilValue(surveyDataState);
    const [answer, setAnswer] = useRecoilState(answerState);
    const setSelectedMenuItem = useSetRecoilState(selectedMenuItemState);
    const setMenuCheck = useSetRecoilState(menuCheckSelector);
    const classes = useStyles();
    const [question, setQuestion] = useState([]);
    const intDiviYn = answer.intDiviYn;

    useEffect(() => {
        if (intDiviYn === "0") {
            const tmpArr = [...surveyData[18].questions];
            tmpArr.splice(3, 2);
            setQuestion(tmpArr)
        } else {
            setQuestion(surveyData[18].questions);
        }
    }, []);

    const handleInputAnswer = (e, column) => {
        const { value } = e.target;

        // 답변 중 '아니오' 일 경우 추가 설명 삭제
        if ("0" === value) {
            const tmpArr = [...surveyData[18].questions];
            tmpArr.splice(3, 2);
            setQuestion(tmpArr)
        } else {
            setQuestion(surveyData[18].questions);
        }

        setAnswer({
            ...answer,
            [column]: value
        });

        setSelectedMenuItem('SURVEY_18');
        setMenuCheck(value !== '');
    };

    const StyledRadio = (props) => {
        return (
            <Radio
                disableRipple
                color="default"
                checked={intDiviYn === props.value}
                checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
                icon={<span className={classes.icon} />}
                onChange={(e) => handleInputAnswer(e, 'intDiviYn')}
                {...props}
            />
        );
    };

    const step18List = surveyData[18].text.map((item) => {
        // item.content = item.content.replace('$stdYear$', appStore.getState().user.userInfo.stdYear);

        return (
            <>
                <FormControlLabel key={'18-' + item.key} name={String(item.toggle)} value={item.key}
                                  control={<StyledRadio />} label={item.content}/>
            </>
        )
    });

    return (
        <>
            <ScrollableAnchor id={"18"}>
                <div>
                <Container style={{background: 'transparent', marginBottom: '10px'}}>
                    <SentenceForm
                        title={surveyData[18].title}
                        sentences={question}
                        step={18}
                    />
                    <FormControl component="fieldset" style={{margin: '10px 20px 0 25px'}}>
                        {/*<Divider />*/}
                        <RadioGroup defaultValue="0" aria-label="" name="" row>
                            {step18List}
                        </RadioGroup>
                        {/*<Divider />*/}
                    </FormControl>
                </Container>
                </div>
            </ScrollableAnchor>
        </>
    );
};

export default Survey8;
